function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/add",
  fillRule: "nonzero"
}, React.createElement("polygon", {
  id: "Shape",
  points: "29.5184587 10.0000012 19.6789725 10.0000012 19.6789725 0 9.83948625 0 9.83948625 10.0000012 0 10.0000012 0 19.9999988 9.83948625 19.9999988 9.83948625 30 19.6789725 30 19.6789725 19.9999988 29.5184587 19.9999988"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/add-icon.93b7b27c.svg";
export { SvgComponent as ReactComponent };